import { CellDragEnteredContext } from './CellDragEnteredProvider';
import { useContext } from 'react';
export default function DragEnteredGridCellCover({editable,cell}){

  let { cellDragEntered, setCellDragEntered } = useContext(CellDragEnteredContext);  

  let { x, y } = cell;

  let thisCellIsDragEntered = editable!==false && y === cellDragEntered[0] && x === cellDragEntered[1];

  return thisCellIsDragEntered && (
    <div
      sciugorole="drag-entered-cell"
      style={{
        position:'absolute',top:0,left:0,
        width:'100%',
        height:'100%',
        background:'#a6d3f7',
        pointerEvents:'none',
        opacity:0.8,
      }}
    />
  )
}
